import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function RequireAuth() {
    const { status, user } = useAuth()

    if (status === 'loading') {
        return <div className="p-4">Loading...</div>
    }

    if (!user) {
        return <Navigate to="/" replace />
    }

    return <Outlet />
}
